<div class="basin-blurred-background-mask" *ngIf="!isPageVisible">
  <div class="basin-gradient-blue-to-bottom load-gradient-background p-d-flex p-jc-center p-ai-center">
    <basin-lottie-animation-player [height]="'60px'" [width]="'60px'" [path]="'/assets/StantecSpinnerWhite.json'"
      [autoplay]="true" [loop]="true"></basin-lottie-animation-player>
  </div>
</div>

<div *ngIf="!isManagerMode" class="basin-pb-4 basin-width-100">
  <p class="note-text">Note: Once the user is added, they cannot be removed for the duration of license. To have a user
    removed, please submit a ticket to the <a href="https://stantecdigitalservices.atlassian.net/servicedesk/customer/portal/29/group/134/create/980" target="_blank"
      class="p-text-button basin-pt-0 basin-pb-0">Debris Flow
      Predictor Help Desk.</a></p>
</div>
<div class="basin-pb-4 basin-width-100">
  <form [formGroup]="form" class="form-container basin-display-flex basin-gap-2">
    <formly-form [form]="form" [fields]="licenseManagerFields" [model]="model" [options]="options"></formly-form>
  </form>
</div>

<!-- URL Section -->
<div class="basin-pb-4 basin-width-100">
 <label for="urlInput" class="basin-mb-1">URL</label>
  <div class="p-fluid p-grid basin-align-items-center">
    <div class="p-col-11 p-md-11">
      <input type="text" name="inviteLinkValue" pInputText [value]="inviteLinkValue" disabled #inviteInput
        class="basin-width-100" />
    </div>
    <div class="p-col-1 p-md-1">
      <button pButton type="button" class="p-button-text" (click)="copyToClipboard()" pTooltip="Copy to clipboard"
        tooltipPosition="top">
        <span class="material-icons"> sticky_note_2 </span>
      </button>
    </div>
  </div>
</div>

<div class="basin-display-flex basin-justify-content-end basin-width-100">
  <button pButton type="button" (click)="onCancel()" class="p-button-text basin-mr-6">
    Cancel
  </button>
  <button pButton [disabled]="!IsTextEntered()" type="submit" (click)="onSave()" class="p-button-text">
    Send Invite
  </button>
</div>